












import Vue from "vue";
import { startAuthUI } from "@/firebase";

export default Vue.extend({
  name: "FirebaseSignIn",

  mounted() {
    const element = this.$el.querySelector("#auth-ui");
    if (element) startAuthUI(element);
  },
});
